<template>
    <div class="card-data">
        <Tooltip
            v-show="tip"
            :tip="tip" />
        <div class="card-title">
            <h5 class="title">{{title}}</h5>
            <small>{{sub}}</small>
        </div>
        <div v-if="!loader">
            <Loader/>
        </div>
        <EmptyStateChart v-else-if="amount==0"
        :title="titleEmpty"
        :caption="captionEmpty"
        />
        <div v-if="loader&&amount!=0" class="card-dwelltime visitors">
            <div style="text-align: center">
                <ICountUp
                    :endVal="amount"
                    :options="options"
                    class="dwelltime-data"
                    />
                <p class="infra-group">{{amountDesc}}</p>
            </div>
        </div>
        
    </div>
</template>

<script>
import ICountUp from 'vue-countup-v2'
import Loader from '@/components/Loader'
import Tooltip from '@/components/Tooltip'
import EmptyStateChart from '@/components/EmptyStateChart'


export default {
    name: 'AmountSingle',
    components: {
        ICountUp,
        Loader,
        Tooltip,
        EmptyStateChart
    },
    props: {
        title: {
            type: String,
            required: true
        },
        sub: {
            type: String,
            required: true
        },
        amount: {
            type: Number,
            required: true
        },
        loader: {
            type: Boolean,
            default: false
        },
        amountDesc: {
            type: String,
            required: true
        },
        tip: {
            type: String,
            default: ''
        },
        captionEmpty:{
            type: String,
            default: "Puedes consultar la vista de los últimos 7 o 30 días.",
        },
        titleEmpty: {
            type: String,
            default: "Este gráfico no esta disponible para esta vista"
        }
    },
    data: function(){
        return {
            options: {
                useEasing: true,
                useGrouping: true,
                duration: 0.6,
                separator: '.',
                decimal: ',',
                prefix: '',
                suffix: ''
            }
        }
    }
}
</script>

<style lang="sass">  
.card-data
    .card-dwelltime
        &.visitors
            font-size: 32px
            @include tablet-landscape
                font-size: 24px
.card-data .infra-group 
    font-family: $body-font
    font-size: 12px
    font-weight: 300
    color: $dark
.visitors .dwelltime-data
    @include tablet-portrait
    font-size: 24px
</style>